import React from "react"
import { cn } from "../utils"
import { Icon, type IconName } from "../icon"
import { type NoteVariant, useNoteContext } from "./note-context"

const defaultIconNames: Record<NoteVariant, IconName> = {
  info: "lightbulb",
  upsell: "information-circle",
  success: "check-circle",
  warning: "alert-circle",
  error: "alert-triangle"
}

export type NoteIconProps = {
  name?: IconName
  className?: string
}

export function NoteIcon({ name, className }: NoteIconProps) {
  const { variant } = useNoteContext()

  return (
    <div
      className={cn(
        "[grid-area:icon] flex items-center justify-center",
        className
      )}
      data-slot="note-icon"
    >
      <Icon name={name ?? defaultIconNames[variant]} />
    </div>
  )
}
